import React, { useContext } from 'react';
import { MockContext } from '../components/mock-provider/MockProvider';
import { apis } from './api';

const APIContext = React.createContext();

const APIProvider = ({ children }) => {
  const { activeMockApis } = useContext(MockContext) ?? {};

  const computedApis = {
    ...apis,
    ...activeMockApis,
  };

  return (
    <APIContext.Provider value={computedApis}>{children}</APIContext.Provider>
  );
};

export { APIProvider, APIContext };
